export default [
  {
    path: "/manager/home",
    name: "Home",
    meta: {
      title: "企业营销通",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/home")
  },
  {
    path: "/manager/userCenter",
    name: "UserCenter",
    meta: {
      title: "用户中心",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/userCenter")
  },
  {
    path: "/manager/manageOrder",
    name: "ManageOrder",
    meta: {
      title: "我的订单",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/manageOrder")
  },
  {
    path: "/manager/poster",
    name: "Poster",
    meta: {
      title: "海报",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/poster")
  },
  {
    path: "/manager/managerCreateOrder",
    name: "ManagerCreateOrder",
    meta: {
      title: "提单",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/createOrder")
  },
  {
    path: "/manager/manageOrderDetail",
    name: "ManageOrderDetail",
    meta: {
      title: "订单详情",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/manageOrderDetail")
  },
  {
    path: "/manager/commissionDetail",
    name: "CommissionDetail",
    meta: {
      title: "营豆明细",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/commissionDetail")
  },
  {
    path: "/manager/singalCommissionDetail",
    name: "SingalCommissionDetail",
    meta: {
      title: "佣金详情",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/singalCommissionDetail")
  },
  {
    path: "/manager/withdrawalApplication",
    name: "WithdrawalApplication",
    meta: {
      title: "提现申请",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/withdrawalApplication")
  },
  {
    path: "/manager/addBankCard",
    name: "AddBankCard",
    meta: {
      title: "绑定银行卡",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/addBankCard")
  },
  {
    path: "/manager/addBankManage",
    name: "AddBankManage",
    meta: {
      title: "银行卡管理",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/addBankManage")
  },
  {
    path: "/manager/myMemberList",
    name: "MyMemberList",
    meta: {
      title: "队长收益",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/myMemberList")
  },
  {
    path: "/manager/homeAdLeft",
    name: "HomeAdLeft",
    meta: {
      title: "企业营销通",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/homeAdLeft")
  },
  {
    path: "/manager/homeAdRight",
    name: "HomeAdRight",
    meta: {
      title: "企业营销通",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/homeAdRight")
  },
  {
    path: "/manager/examplePage",
    name: "ExamplePage",
    meta: {
      title: "开通说明",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/examplePage")
  },
  {
    path: "/manager/hmrzPay",
    name: "HmrzPay",
    meta: {
      title: "订单支付",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/hmrzPay")
  },
  {
    path: "/manager/hmrzOrderDetail",
    name: "HmrzOrderDetail",
    meta: {
      title: "订单详情",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/hmrzOrderDetail")
  },
  {
    path: "/manager/fourhundredPage",
    name: "FourhundredPage",
    meta: {
      title: "企业400电话",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/fourhundredPage")
  },
  {
    path: "/manager/fourhundredDetail",
    name: "FourhundredDetail",
    meta: {
      title: "号码详情",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/fourhundredDetail")
  },
  {
    path: "/manager/userDetail",
    name: "UserDetail",
    meta: {
      title: "个人信息",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/userDetail")
  },
  {
    path: "/manager/userAuthent",
    name: "UserAuthent",
    meta: {
      title: "实名认证",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/userAuthent")
  },
  {
    path: "/manager/userAdvice",
    name: "UserAdvice",
    meta: {
      title: "服务协议",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/userAdvice")
  },
  {
    path: "/manager/infoView",
    name: "InfoView",
    meta: {
      title: "号码认证资料",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/manager/informationView")
  },
  {
    path: "/thirdTf/posterList",
    name: "PosterList",
    meta: {
      title: "产品宣传海报",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/thirdTf/posterList")
  },
  {
    path: "/thirdTf/posterDetail",
    name: "PosterDetail",
    meta: {
      title: "海报",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/thirdTf/posterDetail")
  },
  {
    path: "/thirdTf/moneyHistory",
    name: "MoneyHistory",
    meta: {
      title: "提现记录",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/thirdTf/moneyHistory")
  },
  {
    path: "/thirdTf/moneyHistoryDetail",
    name: "MoneyHistoryDetail",
    meta: {
      title: "提现详情",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/thirdTf/moneyHistoryDetail")
  },
  {
    path: "/thirdTf/ringTfOrderDetail",
    name: "RingTfOrderDetail",
    meta: {
      title: "订单详情",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/thirdTf/ringTfOrderDetail")
  },
  {
    path: "/thirdTf/ringTfInfoView",
    name: "RingTfInfoView",
    meta: {
      title: "彩铃统付资质",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/thirdTf/ringTfInfoView")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/manager.js